import { instance } from '@/services/iss-nattag-api.service'
import { DeviationType } from '@/types/deviation-type'
import { AxiosResponse } from 'axios'

const URL = 'deviation-type'

export const getDeviationTypes = (): Promise<AxiosResponse<DeviationType[]>> =>
  instance.get(`${URL}`)
